export default function DataTable({ columns, data }) {
  const format = (v) =>
    typeof v === "number"
      ? v.toLocaleString("en-IN", { maximumFractionDigits: 2 })
      : v;

  const isNumericColumn = (c) =>
    data.length > 0 && typeof data.find((r) => r[c] !== undefined)?.[c] === "number";

  if (!data || data.length === 0) {
    return (
      <div className="table-wrap">
        <div className="empty-state">No records in this range.</div>
      </div>
    );
  }

  return (
    <div className="table-wrap">
      <table>
        <thead>
          <tr>
            {columns.map((c) => (
              <th key={c} className={isNumericColumn(c) ? "num" : undefined}>
                {c.replace(/_/g, " ")}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.map((row, i) => (
            <tr key={i}>
              {columns.map((c) => (
                <td key={c} className={typeof row[c] === "number" ? "num" : undefined}>
                  {format(row[c])}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
